<template>
  <div>
    <template>
      <v-alert
        :value="isCreating"
        class="ma-0"
        type="info">{{ $t('pleaseFillCompanyData') }}</v-alert>
      <company-editor
        :company="company"
        :error-messages="errorMessages"
        :is-loading="isLoading"
        @clearErrors="errorMessages = {}"
        @saveCompany="saveCompany"/>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CompanyApi from '@/api/CompanyApi'
import CompanyEditor from './CompanyEditor.vue'

export default {
  name: 'MyCompany',
  components: {
    CompanyEditor
  },
  data () {
    return {
      isCreating: false,
      company: null,
      errorMessages: {},
      isLoading: false
    }
  },
  methods: {
    ...mapActions('user', ['updateUser']),
    async saveCompany (companyObj) {
      try {
        this.isLoading = true
        let response
        if (this.isCreating) {
          response = await CompanyApi.createCompany(companyObj)
          await this.updateUser()
          this.isCreating = false
        } else {
          response = await this.editCompanyByRole(companyObj)
        }
        this.$notification(response)
      } catch (e) {
        if (e.errors.message) {
          this.$notification(e)
        }
        this.errorMessages = e.errors
      }
      this.isLoading = false
    },
    editCompanyByRole (companyObj) {
      return CompanyApi.editCompany(companyObj)
    }
  },
  i18n: {
    messages: {
      en: {
        pleaseFillCompanyData: 'Please fill out all the company data to use the system'
      },
      tr: {
        pleaseFillCompanyData: 'Sistemi kullanmak için, lütfen tüm şirket bilgilerini doldurun'
      },
      de: {
        pleaseFillCompanyData: 'Füllen sie bitte alle Daten aus, um die Plattform zu nutzen'
      },
      ru: {
        pleaseFillCompanyData: 'Пожалуйста, заполните все данные компании, чтобы использовать систему'
      }
    }
  },
  async created () {
    try {
      this.company = await CompanyApi.getCompany()
      this.isCreating = false
    } catch (e) {
      this.company = {
        name: '',
        street: '',
        city_id: null,
        phone: '',
        fax: '',
        email: '',
        vat_number: ''
      }
      this.isCreating = true
    }
  }
}
</script>
